import * as mockAdapter from './communications/communicationsMockAdapter.js';
import * as apiAdapter from './communications/communicationsApiAdapter.js';

const API_BASE = process.env.REACT_APP_COMMUNICATIONS_API || '';
const USE_MOCK =
  process.env.REACT_APP_COMMUNICATIONS_USE_MOCK === 'true' || !API_BASE;

function adapter() {
  return USE_MOCK ? mockAdapter : apiAdapter;
}

export function isCommunicationsPreviewMode() {
  return USE_MOCK;
}

export async function getProjectConnections(projectId) {
  return adapter().getProjectConnections(projectId);
}

export async function getCommunicationsFeed(projectId, filters) {
  return adapter().getCommunicationsFeed(projectId, filters);
}

export async function getProductivitySummary(projectId) {
  return adapter().getProductivitySummary(projectId);
}

export async function getCommunicationsIssues(projectId) {
  return adapter().getCommunicationsIssues(projectId);
}

export async function configureCommunications(projectId, config) {
  return adapter().configureCommunications(projectId, config);
}

export async function listAvailableMicrosoftResources(projectId, resourceType) {
  return adapter().listAvailableMicrosoftResources(projectId, resourceType);
}

export async function refreshFeed(projectId) {
  return adapter().refreshFeed(projectId);
}

export async function askAlignmentQuestion(projectId, payload) {
  return adapter().askAlignmentQuestion(projectId, payload);
}

export async function recordAlignedDecision(projectId, payload) {
  return adapter().recordAlignedDecision(projectId, payload);
}

export async function exportForComplianceScan(_projectId, _feedItemIds) {
  if (USE_MOCK) {
    return { status: 'preview', message: 'Compliance scan export is not available in preview mode.' };
  }
  throw new Error('exportForComplianceScan is not implemented');
}

const communicationsService = {
  isCommunicationsPreviewMode,
  getProjectConnections,
  getCommunicationsFeed,
  getProductivitySummary,
  getCommunicationsIssues,
  configureCommunications,
  listAvailableMicrosoftResources,
  refreshFeed,
  askAlignmentQuestion,
  recordAlignedDecision,
  exportForComplianceScan,
};

export default communicationsService;
